module.exports = __webpack_public_path__ + "img/1958-volkswagen-deluxe-micro-bus-34.3a586d5d.jpg";